module.exports = __webpack_public_path__ + "img/sc-cover-papa.802fda64.png";